export default __webpack_public_path__ + "static/media/SackBasicsNylon1.5bff5362.jpg";